module.exports = __webpack_public_path__ + "img/hr-steam.b27dedd1.png";